import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import ZoomSessionWrapper from 'components/Zoom/ZoomSessionWrapper';
import { NotifySnackbar } from 'components/NotifySnackbar/NotifySnackbar';
import LoadingLayer from 'components/LoadingLayer/LoadingLayer';
import Header from 'components/Header/Header';
import { MobileMenu } from 'components/Menu/MobileMenu/MobileMenu';
import ScrollToTop from 'components/ScrollToTop/ScrollToTop';
import { useProtectedRoute } from 'shared/guards/useProtectedRoute';
import { urls } from 'shared/constants/routing.constants';
import Video from 'pages/Main/Video/Video';
import Stream from 'pages/Main/Stream/Stream';
import DebatesFeed from 'pages/Main/DebatesFeed/DebatesFeed';
import ChallengesFeed from 'pages/Main/ChallengesFeed/ChallengesFeed';
// import Help from 'pages/Main/Help/Help';
import About from 'pages/Main/About/About';
import PrivacyPolicy from 'pages/LegalPages/PrivacyPolicy/PrivacyPolicy';
import TermsAndConditions from 'pages/LegalPages/TermsAndConditions/TermsAndConditions';
import CommunityGuidelines from 'pages/LegalPages/CommunityGuidelines/CommunityGuidelines';
import ConsentToDataProcessing from 'pages/LegalPages/ConsentToDataProcessing/ConsentToDataProcessing';
import FullCard from 'pages/Main/FullCard/FullCard';
import Footer from 'components/Footer/Footer';
import { PasswordRecovery } from './PasswordRecovery/PasswordRecovery';
import { NotFound } from './NotFound/NotFound';
import { EmailVerify } from './EmailVerify/EmailVerify';
import Account from './Main/Account/Account';
import GenerateTopics from './Main/GenerateTopics/GenerateTopics';

const AppLayout: React.FC<any> = ({ ...props }) => (
  <Box>
    <ScrollToTop />
    <Header />
    <Stack
      direction="row"
      sx={{
        p: { lg: '0 40px 0', xs: '0 22px 0' },
        minHeight: {
          lg: 'calc(100vh - 104px - 306px)',
          md: 'calc(100vh - 76px - 191px)',
          xs: 'calc(100vh - 68px - 401px)',
        },
      }}
    >
      <Routes>
        <Route path={urls.commonPages.home} element={<DebatesFeed />} />
        <Route path={urls.commonPages.challenges} element={<ChallengesFeed />} />
        {/* <Route path={urls.commonPages.help} element={<Help />} /> */}
        <Route path={urls.commonPages.about} element={<About />} />
        <Route path={urls.commonPages.privacyPolicy} element={<PrivacyPolicy />} />
        <Route path={urls.commonPages.termsAndConditions} element={<TermsAndConditions />} />
        <Route
          path={urls.commonPages.ConsentToDataProcessing}
          element={<ConsentToDataProcessing />}
        />
        <Route path={urls.commonPages.communityGuidelines} element={<CommunityGuidelines />} />

        <Route path={urls.myPages.profile} element={useProtectedRoute(<Account />)} />
        <Route path={urls.myPages.myChallenges} element={useProtectedRoute(<Account />)} />
        <Route path={urls.myPages.myDebates} element={useProtectedRoute(<Account />)} />
        {/* <Route path={urls.myPages.help} element={useProtectedRoute(<Help />)} /> */}

        <Route path={`${urls.commonPages.emailVerify}/:uidb64/:token`} element={<EmailVerify />} />
        <Route
          path={`${urls.commonPages.passwordResetConfirm}/:uidb64/:token`}
          element={<PasswordRecovery />}
        />

        <Route path={`${urls.commonPages.debateCard}/:currentId`} element={<FullCard />} />
        <Route path={`${urls.commonPages.challengeCard}/:currentId`} element={<FullCard />} />

        <Route
          path={`${urls.myPages.video}/:debateId`}
          element={useProtectedRoute(
            <ZoomSessionWrapper>
              <Video footerProps={props} {...props} />
            </ZoomSessionWrapper>,
          )}
        />
        <Route
          path={`${urls.commonPages.stream}/:debateId`}
          element={
            <ZoomSessionWrapper>
              <Stream />
            </ZoomSessionWrapper>
          }
        />

        <Route path="/index.html" element={<DebatesFeed />} />
        {/**
         * This route is indeed sending to a stream, which, for now, by debateId, generated in
         * video component, accesses the video session stream
         */}
        <Route
          path={urls.commonPages.generateTopics}
          element={useProtectedRoute(<GenerateTopics />)}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <MobileMenu />
    </Stack>
    <Footer />
    <NotifySnackbar />
    <LoadingLayer />
  </Box>
);

export default AppLayout;
